import {FixedQueue} from '../shared/fixed-queue';
import {SearchRequest} from './search-request.model';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SearchCacheService{

  private localSearchCache = new FixedQueue<SearchRequest>(environment.cache.cacheSize, SearchCacheService.canClean);

  public getFromCache(searchRequest: SearchRequest): SearchRequest{
    this.localSearchCache.clean();
    return this.localSearchCache.find(it => SearchCacheService.equalsAll(searchRequest, it));
  }

  public getFromCacheSkipPage(searchRequest: SearchRequest): SearchRequest{
    this.localSearchCache.clean();
    return this.localSearchCache.find(it => SearchCacheService.equalsAllWithoutPage(searchRequest, it));
  }

  public putInCache(searchRequest: SearchRequest){
    this.localSearchCache.clean();
    this.localSearchCache.push(searchRequest);
  }

  private static equalsAll(searchRequest: SearchRequest, it: SearchRequest) {
    return SearchCacheService.equalsAllWithoutPage(searchRequest, it) && searchRequest.page == it.page;
  }

  private static equalsAllWithoutPage(searchRequest: SearchRequest, it: SearchRequest){
    return false;
    //TODO fix using response
    // return searchRequest.filter == it.filter
    //   && searchRequest.pageSize == it.pageSize
    //   && searchRequest.phrase == it.phrase
    //   && searchRequest.sort == it.sort
    //   && searchRequest.textOnly == it.textOnly;
  }

  private static canClean(searchRequest: SearchRequest, index: number, items: SearchRequest[]): boolean{
    return (Date.now() - searchRequest.timestamp) > environment.cache.cacheTimeInMilis;
  }

}
